import create from 'zustand'

interface AssetDrawerState {
    isTabClicked: boolean,
    setIsTabClicked: (value: boolean) => void,
    saveForm: boolean,
    setSaveForm: (value: boolean) => void,
    loadForm: boolean,
    setLoadForm: (value: boolean) => void,
    isSavingIMS: boolean,
    setIsSavingIMS: (value: boolean) => void,
}

export const useAssetDrawerStore = create<AssetDrawerState>((set) => ({
    isTabClicked: false,
    saveForm: false,
    loadForm: false,
    isSavingIMS: false,
    setSaveForm: (value: boolean) => set({ saveForm: value }),
    setLoadForm: (value: boolean) => set({ loadForm: value }),
    setIsTabClicked: (value: boolean) => set({ isTabClicked: value }),
    setIsSavingIMS: (value: boolean) => set({ isSavingIMS: value })
}));
